import React from 'react';
import {useSelector} from 'react-redux';
import IconBenefitAcquire from 'assets/inviteABite/iab-benefit-acquire.svg';
import IconBenefitBoost from 'assets/inviteABite/iab-benefit-boost.svg';
import IconBenefitControl from 'assets/inviteABite/iab-benefit-control.svg';
import IconBenefitQuality from 'assets/inviteABite/iab-benefit-quality.svg';
import ImageHero from 'assets/inviteABite/iab-hero-img.svg';
import ImageStepReward from 'assets/inviteABite/iab-step-reward-img.svg';
import ImageStepShare from 'assets/inviteABite/iab-step-share-img.png';
import ImageStepRewarded from 'assets/inviteABite/iab-step-rewarded-img.svg';
import ImageBottomBanner from 'assets/inviteABite/iab-bottom-banner.svg';
import {
  IABBenefitCard,
  IABBenefitDescription,
  IABBenefitGrid,
  IABBenefitIcon,
  IABBenefitIconBox,
  IABBenefitTitle,
  IABBottomBanner,
  IABBottomBannerIcon,
  IABBottomBannerText,
  IABBottomBannerTextBlock,
  IABBottomBannerTitle,
  IABButtonRed,
  IABButtonYellow,
  IABHero,
  IABHeroDescription,
  IABHeroIllustration,
  IABHeroLabel,
  IABHeroTextBlock,
  IABHeroTitle,
  IABSectionTitle,
  IABStepCard,
  IABStepDescription,
  IABStepGrid,
  IABStepIllustration,
  IABStepLabel,
  IABStepTitle
} from 'routes/App/inviteABite/EmptyState/styles';

const JOIN_URL = 'https://share.hsforms.com/1SjnI8IRNQSSI8Cin6tv8Zw21htm';

const STEPS = [
  {
    label: 'Step 1',
    title: 'You set the reward',
    description:
      'Choose a percentage discount (e.g. 20%) that both the referrer and the new customer will receive.',
    image: ImageStepReward
  },
  {
    label: 'Step 2',
    title: 'Customers share',
    description:
      'After ordering, your customers get a unique referral link they can share with friends and family.',
    image: ImageStepShare
  },
  {
    label: 'Step 3',
    title: 'Both get rewarded',
    description:
      'When a first-time customer orders using the link, they get the discount — and so does the person who referred them.',
    image: ImageStepRewarded
  }
];

const BENEFITS = [
  {
    title: 'Acquire customers for free',
    description: 'No upfront cost — you only reward when a real order happens.',
    icon: IconBenefitAcquire
  },
  {
    title: 'Higher quality leads',
    description:
      'Referred customers come with built-in trust. They already know your food is worth trying.',
    icon: IconBenefitQuality
  },
  {
    title: 'Boost repeat orders',
    description:
      'The referrer gets a reward too, bringing them back for another order.',
    icon: IconBenefitBoost
  },
  {
    title: 'You control the cost',
    description:
      'Set your own discount percentage. Adjust it anytime based on what works for your margins.',
    icon: IconBenefitControl
  }
];

const EmptyState = () => {
  const locationName = useSelector(
    (state) =>
      state.user?.activeLocation?.BusinessName ||
      state.user?.activeLocation?.FullName ||
      ''
  );

  const handleJoinClick = (placement) => {
    if (window?.posthog) {
      window.posthog.capture('iab_join_button_click', {
        location_name: locationName,
        placement
      });
    }
    window.open(JOIN_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <IABHero>
        <IABHeroTextBlock>
          <IABHeroLabel>Invite a Bite</IABHeroLabel>
          <IABHeroTitle>
            Turn your best customers into
            <br />
            your best marketers
          </IABHeroTitle>
          <IABHeroDescription>
            Let your customers share their love for your food. When they refer a
            friend, both get a reward — and you get a new regular.
          </IABHeroDescription>
          <IABButtonRed
            className='ButtonMedium'
            onClick={() => handleJoinClick('hero_cta')}
          >
            <span>Join Invite a Bite</span>
          </IABButtonRed>
        </IABHeroTextBlock>
        <IABHeroIllustration src={ImageHero} alt='' />
      </IABHero>

      <IABSectionTitle>How it works</IABSectionTitle>
      <IABStepGrid>
        {STEPS.map((step) => (
          <IABStepCard key={step.label}>
            <IABStepLabel>{step.label}</IABStepLabel>
            <IABStepTitle>{step.title}</IABStepTitle>
            <IABStepDescription>{step.description}</IABStepDescription>
            <IABStepIllustration src={step.image} alt='' />
          </IABStepCard>
        ))}
      </IABStepGrid>

      <IABBenefitGrid>
        <IABSectionTitle className='inGrid'>
          Why restaurants love Invite a Bite
        </IABSectionTitle>
        {BENEFITS.map((benefit) => (
          <IABBenefitCard key={benefit.title}>
            <IABBenefitIconBox>
              <IABBenefitIcon src={benefit.icon} alt='' />
            </IABBenefitIconBox>
            <div>
              <IABBenefitTitle>{benefit.title}</IABBenefitTitle>
              <IABBenefitDescription>
                {benefit.description}
              </IABBenefitDescription>
            </div>
          </IABBenefitCard>
        ))}
      </IABBenefitGrid>

      <IABBottomBanner>
        <IABBottomBannerIcon src={ImageBottomBanner} alt='' />
        <IABBottomBannerTextBlock>
          <IABBottomBannerTitle>
            Ready to grow through word-of-mouth?
          </IABBottomBannerTitle>
          <IABBottomBannerText>
            It takes less than 2 minutes to set up. You can adjust or pause
            anytime.
          </IABBottomBannerText>
        </IABBottomBannerTextBlock>
        <IABButtonYellow
          className='ButtonMedium'
          onClick={() => handleJoinClick('bottom_cta')}
        >
          <span>Join Invite a Bite</span>
        </IABButtonYellow>
      </IABBottomBanner>
    </>
  );
};

export default EmptyState;
